module.exports = __webpack_public_path__ + "static/media/21ECLAC20.380a0ef8.jpg";